import { createContext, useContext, type RefObject } from 'react';

export interface ScrollToEndContextValue {
  scrollToEnd: () => void;
  endRef: RefObject<HTMLDivElement | null>;
}

export const ScrollToEndContext = createContext<
  ScrollToEndContextValue | undefined
>(undefined);

export const useScrollToEnd = () => {
  const context = useContext(ScrollToEndContext);
  if (context === undefined) {
    throw new Error('useScrollToEnd must be used within a ScrollToEndProvider');
  }
  return context;
};
